import { defineMessages } from "react-intl";

const messages = defineMessages({
    groups: {
        id: "memory.header.groups",
    },
    moderation: {
        id: "menu.moderation",
    },
    registration: {
        id: "menu.registration",
    },
    login: {
        id: "menu.login",
    },
    logout: {
        id: "menu.logout",
    },
    account: {
        id: "menu.account",
    },
    help: {
        id: "help.title",
    },
});

export default messages;
